import { useState, useEffect } from 'react';
import { getKlaritySpecialtyListByPageId } from 'api/operation';
import { message } from 'antd';
import { ISpecialty } from 'types/operation';

const useGetKlaritySpecialtiesByPageId = (pageId: string): [ISpecialty[], boolean, () => void] => {
    const [specialties, setSpecialties] = useState<ISpecialty[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchSpecialties = async () => {
        setLoading(true);
        try {
            const res = await getKlaritySpecialtyListByPageId(pageId);
            if (res && !res.error) {
                setSpecialties(res.data?.data || []);
            } else {
                message.error(res?.error);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchSpecialties();
    }, [pageId]);

    return [specialties, loading, fetchSpecialties];
};

export default useGetKlaritySpecialtiesByPageId;
